import type * as React from "react";
import { Label } from "@/components/ui/label";
import { RadioGroupItem } from "@/components/ui/radio-group";
import { cn } from "@/lib/utils";

interface Props {
  value: string;
  id: string;
  className?: string;
  children: React.ReactNode;
}

function RadioGroupItemWithLabel({ value, id, className, children }: Props) {
  const labelId = `${id}-label`;
  return (
    <Label
      htmlFor={id}
      className={cn(
        "flex h-12 cursor-pointer items-center gap-3 rounded-lg border border-border px-4 has-data-[state=checked]:border-primary has-data-[state=checked]:bg-primary/5",
        className,
      )}
    >
      <RadioGroupItem value={value} id={id} aria-labelledby={labelId} />
      <span id={labelId} className="text-sm font-medium">
        {children}
      </span>
    </Label>
  );
}

export { RadioGroupItemWithLabel };
